<template>
  <div>
    <v-row>
      <v-col>Show this category if {{ parentNodeName }} is equal to </v-col>
      <v-col>
        <v-select
          :items="parentRecord.meta.choices"
          v-model="conditionHolder"
          @change="setConditions"
        ></v-select
      ></v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    node: Object,
    parentNodeId: String,
    parentNodeName: String,
    selectedRecord: Object,
    parentRecord: Object,
    index: Number,
    prexistingCondition: String
  },
  created() {
    if (this.prexistingCondition != this.index) {
      this.conditionHolder = this.prexistingCondition.trim();
      this.setConditions(this.conditionHolder);
    }
  },
  data() {
    return {
      conditionHolder: ""
    };
  },
  methods: {
    setConditions(condition) {
      let conditionObject = {
        condition,
        index: this.index
      };
      this.$emit("setCondition", conditionObject);
    }
  }
};
</script>

<style></style>
